import React from 'react';
import { Icon } from '@iconify/react';

export default function App(props) {

  var icon = props.icon;
  var iconText = props.iconText;
  var iconStyle = props.iconStyle;
  var iconHeight = props.iconHeight;
  var oppositeColor = props.oppositeColor;
  var backScreen = props.backScreen;
  var onClick = function(e){};
  if (props.onClick){
    onClick = props.onClick;
  }
 
  var className = "btn btn-solid-lg ";
  if (oppositeColor){
    className = "btn btn-solid-lgopposite "
  }
  if (backScreen){
    className = 'btn btn-secondary';
  }
  
  var iconStyleOut = {};
  if (iconStyle){
    iconStyleOut = iconStyle;
  }

  var iconHeightOut = '20';
  if (iconHeight){
    iconHeightOut = iconHeight;
  }
  var iconPiece;
  if (icon){
    iconPiece = <Icon height={iconHeightOut} icon={icon} />
  }
  if (iconText){
    var classNameInside = 'btn-solid-lg-text';
    iconPiece = <i className="qtip tip-bottom" data-tip={iconText} style={iconStyleOut}><div className={classNameInside}>{iconPiece}</div></i>
  }
  return <button type="button" className={className} onClick={onClick} style={iconStyleOut}>{iconPiece}&nbsp;&nbsp;&nbsp;{props.title}</button> 
}
